import { handleActions } from 'redux-actions'

import { resetContentState } from '@tabeeb/modules/shared/content/actions'
import * as rawActions from '../actions'

const defaultState = []

export default handleActions(
  {
    [rawActions.addDeletedPages](state, action) {
      return [...state, ...action.payload]
    },
    [rawActions.setDeletedPages](state, action) {
      return action.payload
    },
    [rawActions.filterDeletedPages](state, action) {
      const idsToRemove = action.payload

      return state.filter((page) => idsToRemove.findIndex((id) => id === page.id) === -1)
    },
    [resetContentState]() {
      return defaultState
    },
  },
  defaultState
)
